import React from 'react';

import { useGameBridge } from '../SDKProvider/SDKProvider';
import { useRewarded } from '../SDKProvider/useRewarded';

import './styles.css';

import VideoIcon from '../../assets/icons/video.png';

interface AdButtonProps {
    storageKey: string;
    children: React.ReactElement;
    onRewarded?: VoidFunction;
}

export const AdButton: React.FC<AdButtonProps> = (props) => {
    const storageKey = props.storageKey;
    const [watched, setWatched] = React.useState<'watching' | boolean>(false);
    const sdk = useGameBridge();
    const showRewarded = useRewarded();

    React.useEffect(() => {
        sdk.storage
            .get<boolean>(storageKey)
            .then(rewarded => {
                if (rewarded) {
                    setWatched(true);
                }
            });
    }, [props.storageKey]);

    const handleClick = () => {
        if (watched !== false) {
            return;
        }
        setWatched('watching');

        showRewarded({
            onSuccess() {
                setWatched(true);
                sdk.storage.set(storageKey, true);

                if (props.onRewarded) {
                    props.onRewarded();
                }
            },

            onClose() {
                setWatched((watched) => watched === true);
            },
        });
    };

    return watched === true ? props.children : (
        <div className='akjshdgakshgdkajshd-button' onClick={handleClick}>
            <img src={VideoIcon} />
        </div>
    );
};
